import { KEYS } from './constants';
import type { AuthProfile, StoredSession } from './types';

export const AuthStorage = {
  setSession(session: StoredSession) {
    localStorage.setItem(KEYS.accessToken, session.accessToken);
    localStorage.setItem(KEYS.idToken, session.idToken);
    localStorage.setItem(KEYS.expiresAt, JSON.stringify(session.expiresAt));
  },

  clearSession() {
    localStorage.removeItem(KEYS.accessToken);
    localStorage.removeItem(KEYS.idToken);
    localStorage.removeItem(KEYS.expiresAt);
  },

  getExpiresAt(): number | null {
    const raw = localStorage.getItem(KEYS.expiresAt);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as number;
    } catch {
      return null;
    }
  },

  setProfile(profile: AuthProfile) {
    localStorage.setItem(KEYS.profile, JSON.stringify(profile));
  },

  getProfile(): AuthProfile | null {
    const raw = localStorage.getItem(KEYS.profile);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AuthProfile;
    } catch {
      return null;
    }
  },

  clearProfile() {
    localStorage.removeItem(KEYS.profile);
  },
};
